import { ReactElement, useCallback, MouseEvent, useMemo } from 'react';
import classnames from 'classnames';

import styles from './full-view-dialog.module.scss';
import { DialogBackdrop } from './dialog-backdrop';
import { DialogHeaderProps } from './dialog-header';
import { DialogContentProps } from './dialog-content';

type AllowedChild =
    | ReactElement<DialogHeaderProps>
    | ReactElement<DialogContentProps>;

type Props = {
    shown: boolean;
    maxWidth?: number;
    children: AllowedChild | AllowedChild[];
    onClose: () => void;
};

const FullViewDialog = ({ children, maxWidth, shown, onClose }: Props) => {
    const validCloseableSelectors: string[] = useMemo(() => {
        return ['full-view-dialog-close', 'full-view-dialog-backdrop'];
    }, []);

    const handleClose = useCallback(
        (ev: MouseEvent) => {
            const target = ev.target as HTMLElement;
            for (const selector of validCloseableSelectors) {
                if (target.closest(`[data-model="${selector}"]`)) {
                    return onClose();
                }
            }
        },
        [onClose, validCloseableSelectors]
    );

    return (
        <div
            className={classnames({
                [styles.container]: true,
                [styles.shown]: shown,
            })}
            onClick={handleClose}
        >
            <DialogBackdrop />
            <div
                className={styles.dialog}
                style={{ maxWidth: maxWidth ?? '100%' }}
            >
                {children}
            </div>
        </div>
    );
};

export { FullViewDialog };
